import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Model } from 'app/model/backendmodel';
import { Metamodel } from 'app/model/base/model';
import _ from 'lodash';
import { ValueAdapter } from 'app/model/adapters/value.adapter';
import { AdobeExperiencePlatformObjectDataset } from 'app/model/dataset/adobe-experience-platform.dataset';
import { DatasetAdapter } from './dataset.adapter';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(AdobeExperiencePlatformObjectDataset),
    asynchronous: true,
    adapts: {
        name: '*',
        properties: {
            description: '*',
            folder: '*',
            annotations: '*',
            linkedServiceName: '*',
            parameters: '*',
            type: '*',
            typeProperties: {
                datasetId: '*'
            }
        }
    }
})
export class AdobeExperiencePlatformDatasetAdapter extends DatasetAdapter<AdobeExperiencePlatformObjectDataset, Model.DatasetResource> {
    protected async _toResource(dataset: AdobeExperiencePlatformObjectDataset): Promise<Model.DatasetResource> {
        const modelDatasetResource = await super._toResource(dataset) as Model.DatasetResource;
        const modelDataset = this.properties(modelDatasetResource) as Model.AdobeExperiencePlatformDataset;
        modelDataset.type = Metamodel.modelFor(AdobeExperiencePlatformObjectDataset).name;
        modelDataset.typeProperties = {
            datasetId: ValueAdapter.toResource(dataset, AdobeExperiencePlatformObjectDataset.DATASET_ID)
        };
        if (dataset.raw) {
            const parsed = JSON.parse(dataset.raw);
            _.merge(modelDatasetResource, parsed);
        }
        return modelDatasetResource;
    }

    protected async _toModel(modelDatasetResource: Model.DatasetResource, dataset?: AdobeExperiencePlatformObjectDataset): Promise<AdobeExperiencePlatformObjectDataset> {
        if (!dataset) {
            dataset = AdobeExperiencePlatformObjectDataset.MODEL.create<AdobeExperiencePlatformObjectDataset>(modelDatasetResource.name);
        }
        await super._toModel(modelDatasetResource, dataset);
        const model = modelDatasetResource.properties as Model.AdobeExperiencePlatformDataset;
        if (model && model.typeProperties != null) {
            ValueAdapter.toModel(dataset, AdobeExperiencePlatformObjectDataset.DATASET_ID, model.typeProperties.datasetId);
        }
        dataset.raw = JSON.stringify(await ValueAdapter.remainder(this.context, modelDatasetResource, AdobeExperiencePlatformObjectDataset.MODEL));
        return dataset;
    }
}
